import { MePermissionType } from '@nxsys/constants/mePermission';

export const hasPermission = (
  userPermissions: string[],
  requiredPermission: MePermissionType,
): boolean => {
  return userPermissions.includes(requiredPermission);
};

export const hasAllPermissions = (
  userPermissions: string[],
  requiredPermissions: MePermissionType[],
): boolean => {
  return requiredPermissions.every((permission) =>
    hasPermission(userPermissions, permission),
  );
};

export const hasAnyPermission = (
  userPermissions: string[],
  requiredPermissions: MePermissionType[],
): boolean => {
  return requiredPermissions.some((permission) =>
    hasPermission(userPermissions, permission),
  );
};
